(() => {
  const roots = document.querySelectorAll("[data-korede-soup]");

  const normalize = (value) => String(value || "")
    .replace(/\s+/g, "")
    .replace(/[０-９]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xfee0))
    .replace(/の/g, "")
    .replace(/スープ/g, "")
    .replace(/プロテイン/g, "")
    .toLowerCase();

  const sameOption = (actual, expected) => {
    const a = normalize(actual);
    const b = normalize(expected);
    return a === b || a.includes(b) || b.includes(a);
  };

  roots.forEach((root) => {
    const bulkDiscount = root.querySelector("[data-korede-bulk-discount]");
    if (!bulkDiscount) return;

    const capacityButtons = root.querySelectorAll('[data-korede-option="capacity"]');
    const selectedText = root.querySelector("[data-korede-selected-text]");
    const targetCapacity = bulkDiscount.dataset.targetCapacity || "100g";

    const update = () => {
      if (!capacityButtons.length) {
        bulkDiscount.classList.remove("is-visible");
        bulkDiscount.setAttribute("aria-hidden", "true");
        return;
      }

      const selectedButton = Array.from(capacityButtons).find((button) => {
        return button.classList.contains("is-selected") || button.getAttribute("aria-pressed") === "true";
      });
      const selectedCapacity = selectedButton?.dataset.value || selectedText?.textContent || "";
      const shouldShow = sameOption(selectedCapacity, targetCapacity);

      bulkDiscount.classList.toggle("is-visible", shouldShow);
      bulkDiscount.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    };

    capacityButtons.forEach((button) => {
      button.addEventListener("click", () => {
        requestAnimationFrame(update);
        window.setTimeout(update, 0);
      });
    });

    if (selectedText) {
      const observer = new MutationObserver(update);
      observer.observe(selectedText, { childList: true, characterData: true, subtree: true });
    }

    update();
  });
})();
